/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MassUpdateEditableEmployeeRecordPropertiesQuery } from '@coin/shared/core/util-models-v2';
import { PageOfEditableEmployeeRecord } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeRecordSearchResult } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { SaveEditableEmployeeRecordProperties } from '@coin/shared/core/util-models-v2';
import { SaveEditableEmployeeRecordPropertiesRequest } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface EditableViewFieldValuesSupportEmployeeRecordsParams {
  simulationId: string;
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  search?: string;
  page?: number;
  size?: number;
}

export interface EditableViewSupportEmployeeRecordsParams {
  simulationId: string;
  /** Free-text search matching any part of the GID, first name, last name or full name. Applied on top of (not instead of) the column filters below. */
  search?: string;
  /** The GID of the employee. */
  gid?: string;
  /** The first name of the employee. */
  firstname?: string;
  /** The last name of the employee. */
  lastname?: string;
  /** The country (location) of the employee. */
  country?: string;
  /** The ISO country code of the employee\&#39;s place of action. */
  placeOfAction?: Array<string>;
  /** The ARE of the employee. */
  are?: string;
  /** The previous (origin) org code of the employee\&#39;s primary job assignment. */
  oldOrgCode?: string;
  /** The new (simulation) org code of the employee\&#39;s primary job assignment. */
  newOrgCode?: string;
  /** The cost center. Requires permission to see the cost center column. */
  costCenter?: string;
  /** The InCompany Manager GID. Requires permission to see the InCompany Manager columns. */
  inCompanyManagerGid?: string;
  /** The resolved InCompany Manager name. Requires permission to see the InCompany Manager columns. */
  inCompanyManagerName?: string;
  /** The line manager\&#39;s GID. */
  lineManagerGid?: string;
  /** The line manager\&#39;s full name. */
  lineManagerName?: string;
  /** The line manager\&#39;s country. */
  lineManagerCountry?: string;
  /** The line manager\&#39;s ARE. */
  lineManagerAre?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface MassUpdatePropertiesSupportEmployeeRecordsParams {
  simulationId: string;
  massUpdateEditableEmployeeRecordPropertiesQuery?: MassUpdateEditableEmployeeRecordPropertiesQuery;
}

export interface QuerySupportEmployeeRecordsParams {
  simulationId: string;
  /** The unique id of the organisation for the job assignment deviation query. */
  organisationId?: string;
  /** The unique id of the organisation chart for the job assignment deviation query. */
  organisationChartId?: string;
  /** The unique id of the origin organisation chart for the job assignment deviation query. */
  originOrganisationChartId?: string;
  /** The gid for the job assignment deviation query. */
  gid?: string;
  /** The last name for the job assignment deviation query. */
  lastname?: string;
  /** The first name for the job assignment deviation query. */
  firstname?: string;
  /** The organisation code for the job assignment deviation query. */
  orgCode?: string;
  /** The gids for the job assignment deviation query. */
  gids?: Array<string>;
  /** The organisation codes for the job assignment deviation query. */
  orgCodes?: Array<string>;
  /** The places of action for the job assignment deviation query. */
  placesOfAction?: Array<string>;
  /** The assignment states for the job assignment deviation query. */
  assignmentStates?: Array<'NoAssignment' | 'MultiplePrimaryAssignments' | 'OnlySecondaryAssignments'>;
  /** The search string for the job assignment deviation query. */
  search?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SavePropertiesSupportEmployeeRecordsParams {
  simulationId: string;
  saveEditableEmployeeRecordPropertiesRequest?: SaveEditableEmployeeRecordPropertiesRequest;
}

@Injectable({
  providedIn: 'root'
})
export class OrganisationPlanningSupportService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editableViewFieldValuesSupportEmployeeRecords(
    requestParameters?: EditableViewFieldValuesSupportEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public editableViewFieldValuesSupportEmployeeRecords(
    requestParameters?: EditableViewFieldValuesSupportEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public editableViewFieldValuesSupportEmployeeRecords(
    requestParameters?: EditableViewFieldValuesSupportEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public editableViewFieldValuesSupportEmployeeRecords(
    requestParameters?: EditableViewFieldValuesSupportEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('editableViewFieldValuesSupportEmployeeRecords', { simulationId, targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/support/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-records/editable-view/field-values/${this.configuration.encodeParam({ name: 'targetProperty', value: targetProperty, in: 'path', style: 'simple', explode: false, dataType: '0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14', dataFormat: 'int32' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public editableViewSupportEmployeeRecords(
    requestParameters?: EditableViewSupportEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEditableEmployeeRecord>;
  public editableViewSupportEmployeeRecords(
    requestParameters?: EditableViewSupportEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEditableEmployeeRecord>>;
  public editableViewSupportEmployeeRecords(
    requestParameters?: EditableViewSupportEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEditableEmployeeRecord>>;
  public editableViewSupportEmployeeRecords(
    requestParameters?: EditableViewSupportEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('editableViewSupportEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/support/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-records/editable-view`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Country: requestParameters?.country,
        PlaceOfAction: requestParameters?.placeOfAction,
        Are: requestParameters?.are,
        OldOrgCode: requestParameters?.oldOrgCode,
        NewOrgCode: requestParameters?.newOrgCode,
        CostCenter: requestParameters?.costCenter,
        InCompanyManagerGid: requestParameters?.inCompanyManagerGid,
        InCompanyManagerName: requestParameters?.inCompanyManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerCountry: requestParameters?.lineManagerCountry,
        LineManagerAre: requestParameters?.lineManagerAre,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public massUpdatePropertiesSupportEmployeeRecords(
    requestParameters?: MassUpdatePropertiesSupportEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public massUpdatePropertiesSupportEmployeeRecords(
    requestParameters?: MassUpdatePropertiesSupportEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public massUpdatePropertiesSupportEmployeeRecords(
    requestParameters?: MassUpdatePropertiesSupportEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public massUpdatePropertiesSupportEmployeeRecords(
    requestParameters?: MassUpdatePropertiesSupportEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('massUpdatePropertiesSupportEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/support/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-records/properties/mass`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.massUpdateEditableEmployeeRecordPropertiesQuery,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySupportEmployeeRecords(
    requestParameters?: QuerySupportEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeRecordSearchResult>;
  public querySupportEmployeeRecords(
    requestParameters?: QuerySupportEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeRecordSearchResult>>;
  public querySupportEmployeeRecords(
    requestParameters?: QuerySupportEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeRecordSearchResult>>;
  public querySupportEmployeeRecords(
    requestParameters?: QuerySupportEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('querySupportEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/support/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrganisationId: requestParameters?.organisationId,
        OrganisationChartId: requestParameters?.organisationChartId,
        OriginOrganisationChartId: requestParameters?.originOrganisationChartId,
        Gid: requestParameters?.gid,
        Lastname: requestParameters?.lastname,
        Firstname: requestParameters?.firstname,
        OrgCode: requestParameters?.orgCode,
        Gids: requestParameters?.gids,
        OrgCodes: requestParameters?.orgCodes,
        PlacesOfAction: requestParameters?.placesOfAction,
        AssignmentStates: requestParameters?.assignmentStates,
        Search: requestParameters?.search,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePropertiesSupportEmployeeRecords(
    requestParameters?: SavePropertiesSupportEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SaveEditableEmployeeRecordProperties>;
  public savePropertiesSupportEmployeeRecords(
    requestParameters?: SavePropertiesSupportEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SaveEditableEmployeeRecordProperties>>;
  public savePropertiesSupportEmployeeRecords(
    requestParameters?: SavePropertiesSupportEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SaveEditableEmployeeRecordProperties>>;
  public savePropertiesSupportEmployeeRecords(
    requestParameters?: SavePropertiesSupportEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('savePropertiesSupportEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/support/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-records/properties`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.saveEditableEmployeeRecordPropertiesRequest,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
